import React from 'react'
import { useNavigate } from 'react-router-dom';

const Footer = () =>{
  
  const router = useNavigate();
  const pageTurn = (e) => {
    up();
    router(e)
  }

  const up = () => {
     window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' 
    });
}


  return (
    <>
      <section class="bg-primary">
            <div class="max-w-4xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
            <h2 class="text-3xl font-extrabold text-white sm:text-4xl">
            <span class="block">Interested in partnering with us?</span>
            </h2>
            <p class="mt-4 text-lg leading-6 text-indigo-100">We are always looking for talented individuals and innovative partners to join us in our mission.</p>
            <div class="mt-8 flex justify-center gap-4">
            <a class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-lg text-primary bg-white hover:bg-indigo-50" onClick={(e) => pageTurn("/contact")}>Contact Us</a>
            <a class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-primary hover:bg-opacity-90 ring-1 ring-white" href="#">Explore Careers</a>
            </div>
            </div>
       </section>


             <footer class="bg-gray-900 dark:bg-black text-white">
                        <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                        <div class="xl:grid xl:grid-cols-3 xl:gap-8">
                        <div class="space-y-8 xl:col-span-1">
                        <div class="flex items-center gap-4 text-white">
     
                        <h2 class="text-xl font-bold">abjpharmacy</h2>
                        </div>
                        <p class="text-gray-400 text-sm">Innovating for a healthier world.</p>
                        <div class="flex space-x-6">
                        <a class="text-gray-400 hover:text-gray-300" href="#">
                        <span class="sr-only">LinkedIn</span>
                        <svg aria-hidden="true" class="h-6 w-6" fill="currentColor" viewbox="0 0 24 24"><path clip-rule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" fill-rule="evenodd"></path></svg>
                        </a>
                        <a class="text-gray-400 hover:text-gray-300" href="#">
                        <span class="sr-only">X</span>
                        <svg aria-hidden="true" class="h-6 w-6" fill="currentColor" viewbox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></svg>
                        </a>
                        </div>
                        </div>
                        <div class="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
                        <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div>
                        <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">Solutions</h3>
                        <ul class="mt-4 space-y-4" role="list">
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Products</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Pipeline</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Our Science</a></li>
                        </ul>
                        </div>
                        <div class="mt-12 md:mt-0">
                        <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">Company</h3>
                        <ul class="mt-4 space-y-4" role="list">
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">About</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Careers</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">News</a></li>
                        </ul>
                        </div>
                        </div>
                        <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div>
                        <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">Legal</h3>
                        <ul class="mt-4 space-y-4" role="list">
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Privacy Policy</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Terms of Service</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Disclaimer</a></li>
                        </ul>
                        </div>
                        <div class="mt-12 md:mt-0">
                        <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">Contact</h3>
                        <ul class="mt-4 space-y-4" role="list">
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Contact Us</a></li>
                        <li><a class="text-base text-gray-300 hover:text-white" href="#">Support</a></li>
                        </ul>
                        </div>
                        </div>
                        </div>
                        </div>
                        <div class="mt-12 border-t border-gray-700 pt-8">
                        <p class="text-base text-gray-400 xl:text-center">© 2024 abjpharmacy, Inc. All rights reserved.</p>
                        </div>
                        </div>
                </footer>
    </>
  )
}

export default Footer
